<template>
	<component :is="getComponent"></component>
</template>

<script>
import Home from './Home.vue'
import Dashboard from './dashboard.vue'

export default {
	name: 'home',
	computed: {
		getComponent() {
			if (this.$store.getters.userIsAuthenticated) {
				return Dashboard
			}
			return Home
		}
	}
}
</script>

<style>
.card-background-image > div:nth-child(1) {
	opacity: 0.7;
}
</style>
